module.exports = __webpack_public_path__ + "static/media/divanti.703a760b.jpeg";